module.exports = __webpack_public_path__ + "img/Historithon.f989877d.png";